import { Routes } from '@angular/router';

export const CONTENT_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('../../modules/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('../../modules/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'time-zone',
    loadChildren: () => import('../../modules/time-zone/time-zone.module').then(m => m.TimeZoneModule)
  },
  {
    path: 'currency',
    loadChildren: () => import('../../modules/currency/currency.module').then(m => m.CurrencyModule)
  },
  {
    path: 'country',
    loadChildren: () => import('../../modules/country/country.module').then(m => m.CountryModule)
  },
  {
    path: 'domain',
    loadChildren: () => import('../../modules/domain/domain.module').then(m => m.DomainModule)
  },
  {
    path: 'city',
    loadChildren: () => import('../../modules/city/city.module').then(m => m.CityModule)
  },
  {
    path: 'bike-type-group',
    loadChildren: () => import('../../modules/bike-type-group/bike-type-group.module').then(m => m.BikeTypeGroupModule)
  },
  {
    path: 'bike-type',
    loadChildren: () => import('../../modules/bike-type/bike-type.module').then(m => m.BikeTypeModule)
  },
  {
    path: 'nextbike-sync-attempt',
    loadChildren: () => import('../../modules/nextbike-sync-attempt/nextbike-sync-attempt.module').then(m => m.NextbikeSyncAttemptModule)
  },
  {
    path: 'coupon-type',
    loadChildren: () => import('../../modules/coupon-type/coupon-type.module').then(m => m.CouponTypeModule)
  },
  {
    path: 'bike',
    loadChildren: () => import('../../modules/bike/bike.module').then(m => m.BikeModule)
  },
  {
    path: 'coupon',
    loadChildren: () => import('../../modules/coupon/coupon.module').then(m => m.CouponModule)
  },
  {
    path: 'partner',
    loadChildren: () => import('../../modules/partner/partner.module').then(m => m.PartnerModule)
  },
  {
    path: 'campaign',
    loadChildren: () => import('../../modules/campaign/campaign.module').then(m => m.CampaignModule)
  },
  {
    path: 'user',
    loadChildren: () => import('../../modules/user/user.module').then(m => m.UserModule)
  },
  {
    path: 'occupation',
    loadChildren: () => import('../../modules/occupation/occupation.module').then(m => m.OccupationModule)
  },
  {
    path: 'operation',
    loadChildren: () => import('../../modules/operation/operation.module').then(m => m.OperationModule)
  },
  {
    path: 'role',
    loadChildren: () => import('../../modules/role/role.module').then(m => m.RoleModule)
  },
  {
    path: 'car',
    loadChildren: () => import('../../modules/car/car.module').then(m => m.CarModule)
  },
  {
    path: 'slack-city-channel',
    loadChildren: () => import('../../modules/slack-city-channel/slack-city-channel.module').then(m => m.SlackCityChannelModule)
  },
  {
    path: 'time-card',
    loadChildren: () => import('../../modules/time-card/time-card.module').then(m => m.TimeCardModule)
  },
  {
    path: 'stat',
    loadChildren: () => import('../../modules/stat/stat.module').then(m => m.StatModule)
  },
  {
    path: 'export',
    loadChildren: () => import('../../modules/export/export.module').then(m => m.ExportModule)
  },
  {
    path: 'personal-leave-request',
    loadChildren: () => import('../../modules/personal-leave-request/personal-leave-request.module').then(m => m.PersonalLeaveRequestModule)
  },
  {
    path: 'jubilee',
    loadChildren: () => import('../../modules/jubilee/jubilee.module').then(m => m.JubileeModule)
  },
  {
    path: 'customer',
    loadChildren: () => import('../../modules/customer/customer.module').then(m => m.CustomerModule)
  },
  {
    path: 'rental',
    loadChildren: () => import('../../modules/rental/rental.module').then(m => m.RentalModule)
  },
  {
    path: 'api-client',
    loadChildren: () => import('../../modules/api-client/api-client.module').then(m => m.ApiClientModule)
  },
  {
    path: 'workshop',
    loadChildren: () => import('../../modules/workshop/workshop.module').then(m => m.WorkshopModule)
  },
  {
    path: 'issue',
    loadChildren: () => import('../../modules/issue/issue.module').then(m => m.IssueModule)
  },
  {
    path: 'issue-time-log',
    loadChildren: () => import('../../modules/issue-time-log/issue-time-log.module').then(m => m.IssueTimeLogModule)
  },
  {
    path: 'place',
    loadChildren: () => import('../../modules/place/place.module').then(m => m.PlaceModule)
  },
  {
    path: 'celery-task',
    loadChildren: () => import('../../modules/celery-task/celery-task.module').then(m => m.CeleryTaskModule)
  },
  {
    path: 'error',
    loadChildren: () => import('../../modules/error/error.module').then(m => m.ErrorModule)
  },
];
